var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransporteTren(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6E6259",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M3.42 8.95H20.54V2.052C20.539.92 19.606 0 18.459 0H5.5C4.353 0 3.42.92 3.42 2.053v6.896zm5.92-7.565h5.28c.353 0 .64.283.64.632 0 .349-.287.632-.64.632H9.34c-.354 0-.64-.283-.64-.632 0-.349.286-.632.64-.632zM20.539 13.705v-3.493H3.42v3.493c0 1.132.933 2.053 2.08 2.053H18.46c1.147 0 2.08-.921 2.08-2.053zm-14.31.415c-.634 0-1.15-.508-1.15-1.135s.516-1.135 1.15-1.135c.636 0 1.15.508 1.15 1.135s-.514 1.135-1.15 1.135zm11.5 0c-.635 0-1.15-.508-1.15-1.135s.515-1.135 1.15-1.135c.635 0 1.15.508 1.15 1.135s-.515 1.135-1.15 1.135zM18.43 17.02h-1.8l.574 1.098H6.714l.574-1.097H5.487l-1.479 2.827c-.202.388-.048.864.344 1.064.118.06.243.088.367.088.29 0 .569-.156.711-.427l.458-.876H18.03l.458.876c.142.271.421.427.711.427.124 0 .25-.028.367-.088.392-.2.546-.676.343-1.064l-1.479-2.827zM3.227 16.144L.188 19.702c-.284.333-.241.831.096 1.112.15.125.334.186.516.186.227 0 .454-.096.612-.28l3.248-3.804c-.543-.139-1.033-.408-1.433-.772zM23.812 19.702l-3.057-3.58c-.396.367-.883.64-1.423.784l3.256 3.813c.158.185.385.28.612.28.182 0 .365-.06.516-.185.337-.28.38-.779.096-1.112z",
    transform: "translate(2 4)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporteTren);
export default __webpack_public_path__ + "static/media/transporte-tren.13ffa749.svg";
export { ForwardRef as ReactComponent };